<template>
    <el-card class="profile" style="overflow-y: auto">
        <div slot="header" class="clearfix">
            <span>{{id?'新增投票':('编辑 #'+id+' 投票')}}</span>
        </div>
        <div>
            <el-form :model="single" label-width="60px" ref="editForm">
                <el-row >
                    <el-col :span="24" :md="12">
                        <el-form-item label="主题:" prop="subject" :rules="[{required: true, message: '主题不能为空'}]">
                            <el-input v-model="single.subject"
                                      placeholder="请输入主题"
                                      type='text'
                                      size="small">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12">
                        <el-form-item label="用户:">
                            <select v-model="single.visitor_id"
                                       :disabled="user.role_level<4"
                                       class="w-100"
                                       size="small">
                                <option v-for="(x,id) in single.visitors" :key="id" :value="id"
                                           :label="x"></option>
                            </select>
                        </el-form-item>
                    </el-col>
                    <div class="clearfix"></div>
                </el-row>
                <el-row>
                    <el-table :data="single.items" style="width: auto;">
                        <el-table-column
                                label=""
                                width="40">
                            <template slot-scope="scope">
                                <div class="mb-4">
                                <el-button circle plain type="primary" icon="el-icon-plus" size="mini"
                                           @click="addItemAfter(scope.$index)"></el-button>
                                </div>
                                <div>
                                <el-button circle plain type="danger" icon="el-icon-minus" size="mini"
                                           @click="deleteItem(scope.$index)"></el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="数据"
                        >
                            <template slot-scope="scope">

                                <input type="number" class="mb-2 w-100 bg-light" v-model="scope.row.order"/>

                                <el-input size="small" v-model="scope.row.question" class="mb-2 w-100 bg-light"></el-input>
                                <select v-model="scope.row.answer_type" style="width: 100%" class="mb-2 w-100 bg-light">
                                    <option label="单选" value="0"></option>
                                    <option label="多选" value="1"></option>
                                </select>
                                <el-input type="textarea" size="small" v-model="scope.row.answers"></el-input>

                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-form>
        </div>
        <div class="mt-4">
            <div class="line mb-3"></div>
            <el-button @click="handleCancel" class="pull-right">{{'放 弃'}}</el-button>
            <el-button type="primary" @click.native="handleSubmit" :loading="process.loading">{{('提 交')}}</el-button>
        </div>
    </el-card>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        mixins: [],
        name: 'admin-admin',
        data() {
            return {
                model: '',
                id: 0,
                single: {},
            }
        },
        created() {
            this.model = 'Admin.Poll';
            this.id = this.$route.params.id;
            const vm = this;
            this.$api(this.model + '.Get', {id: this.id}).then(res => {
                if (res.data.success) {
                    this.single = res.data.data;
                } else {
                    const text = res.data.text;
                    vm.$alert(text, '错误', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: () => {
                            vm.$router.go(-1);
                        }
                    });
                }
            }).catch(() => {
                vm.$router.go(-1);
            });
        },
        computed: {
            ...mapState(['user', 'preset', 'process']),
        },
        methods: {
            addItemAfter(i) {
                this.single.items.splice(i + 1, 0, {
                    order: i + 2,
                    question: '添加问题',
                    answer_type: '0',
                    answers: '添加答案，请用逗号分割'
                });
            },
            deleteItem(i) {
                if (this.single.items.length > 1) {
                    this.$affirm('确定要删除?').then(() => {
                        this.single.items.splice(i, 1);
                    });
                }
            },
            handleCancel() {
                this.$router.go(-1);
            },
            handleSubmit() {
                this.$api(this.model+'.Edit',this.single,1).then(()=>{
                    this.$router.go(-1);
                });
            }
        }
    }

</script>

<style lang="scss">

</style>
